import { render, staticRenderFns } from "./GuestFrame.vue?vue&type=template&id=2bf57213&scoped=true&"
import script from "./GuestFrame.vue?vue&type=script&lang=js&"
export * from "./GuestFrame.vue?vue&type=script&lang=js&"
import style0 from "./GuestFrame.vue?vue&type=style&index=0&id=2bf57213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf57213",
  null
  
)

export default component.exports